export const APP_VERSION = '0.6.0';
export const APP_NAME = 'MengYin Study';
